<template>

    <div>
        <el-dialog title="" :visible.sync="invoiceShow" :close-on-click-modal="false" width="750px" ref="dialog"
            @close="invoiceClose" top="5vh">
            <div class="invoice-dialog">
                <el-form label-position="left" label-width="120px" :model="form" :rules="rules" ref="form"
                   >
                    <div class="tk-head-flex">
                        <h3 class="tk-head-title">开票信息</h3>
                        <!-- TIPS: 这个按钮随意放那里吧 -->
                        <!-- <el-button type="danger" size="small" @click="refusedInvoiceShow = true">拒绝开票</el-button> -->
                        <!-- End -->
                    </div>
                    <!-- <el-alert title="提示：请确保电子税务局保持登录状态，否则会影响平台开票业务。" type="warning" :closable="false"></el-alert> -->
                    <el-alert :title="tipMsg" type="warning" :closable="false"></el-alert>
                    <el-form-item label="发票类型：" prop="isVatInvoice">
                        <el-radio-group v-model="form.isVatInvoice" size="small">
                            <el-radio label="1">增值税专用发票</el-radio>
                            <el-radio label="0">增值税普通发票</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="发票抬头：" prop="invoiceTitle">
                        <el-input placeholder="请输入发票抬头" size="small" v-model="form.invoiceTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号：" prop="taxNo">
                        <el-input placeholder="请输入纳税人识别号" size="small" v-model="form.taxNo"></el-input>
                    </el-form-item>
                    <el-form-item label="注册地址：" prop="companyAddress">
                        <el-input placeholder="请输入注册地址" size="small" v-model="form.companyAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="注册号码：" prop="companyPhone">
                        <el-input placeholder="请输入注册号码" size="small" v-model="form.companyPhone"></el-input>
                    </el-form-item>
                    <!-- TODO：开户银行是否是select 待产品确认 -->
                    <el-form-item label="开户银行：" prop="bankName">
                        <el-input placeholder="请输入开户银行" size="small" v-model="form.bankName"></el-input>
                    </el-form-item>
                    <!-- End -->
                    <el-form-item label="银行账号：" prop="bankNo">
                        <el-input placeholder="请输入银行账号" size="small" v-model="form.bankNo"></el-input>
                    </el-form-item>
                    <el-form-item label="开票内容：" prop="invoiceContent">
                        <!-- <el-radio-group v-model="form.invoiceContent" size="small">
                        <el-radio label="0">技术服务费</el-radio>
                        <el-radio label="1">技术咨询费</el-radio>
                    </el-radio-group> -->

                        <el-select v-model="form.invoiceContentType" @change="invoiceContentTypeChange">
                            <el-option v-for="items in invoiceContentArray" :key="items.value" :label="items.name"
                                :value="items.value">
                            </el-option>
                        </el-select>

                    </el-form-item>
                    <el-form-item label="开票金额：" prop="invoiceMoney">
                        <!-- <el-input placeholder="请输入开票金额" size="small" v-model="form.invoiceMoney"
                            type="number"></el-input> -->
                            {{form.invoiceMoney}}
                    </el-form-item>
 
                    <el-form-item label="开票税点：" prop="taxPoint">
                        <el-radio-group v-model="form.taxPoint" size="small">
                            <el-radio label="6%"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="规格型号：" prop="Specifications">
                        <el-input placeholder="请输入规格型号" size="small" v-model="form.Specifications"></el-input>
                    </el-form-item>
                    <el-form-item label="发票备注：" prop="invoiceRemarks">
                        <el-input type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入备注"
                            v-model="form.invoiceRemarks">
                        </el-input>
                    </el-form-item>
                    <div class="tk-head-flex">
                        <h3 class="tk-head-title">收件信息</h3>
                    </div>
                    <el-form-item label="邮寄地址：" prop="ExpressAddress">
                        <el-input placeholder="请输入邮寄地址" size="small" v-model="form.ExpressAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="收件人：" prop="consignee">
                        <el-input placeholder="请输入收件人" size="small" v-model="form.consignee"></el-input>
                    </el-form-item>
                    <el-form-item label="收件人电话：" prop="consigneePhone">
                        <el-input placeholder="请输入收件人电话" size="small" v-model="form.consigneePhone"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱地址：" prop="invoiceMailAddress">
                        <el-input placeholder="请输入邮箱地址" size="small" v-model="form.invoiceMailAddress"></el-input>
                    </el-form-item>
                    <br />
                    <el-form-item label=" ">
                        <el-button type="primary" size="small" @click="submitForm('form')" :loading="loading">确认开票</el-button>
                        <!-- <el-button type="danger" size="small">拒绝开票</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog title="拒绝开票" :visible.sync="refusedInvoiceShow" :close-on-click-modal="false" width="600px"
            ref="dialog">
            <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入拒绝收票的原因" v-model.trim="refuseReason">
            </el-input>
            <br />
            <br />
            <br />
            <div style="text-align: center">
                <el-button type="primary" size="medium" @click="refuseBtn()">确 定</el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
import {
    getStorageUserRoleId
} from '@/utils/store'
import eventBus from "@/utils/eventBus.js";
import {
    confirmInvoice, refuseInvoice, ReInvoiceSubmit
} from "@/service/payApi";

export default {
    data() {
        return {
            loading: false,
            invoiceShow: false,
            form: {
                info: {},
                ids: [],
                noteIds: [],
                senderCode: "",
                adminUserId: '',
                bankName: '',
                bankNo: '',
                companyAddress: '',
                companyPhone: '',
                consignee: '',
                consigneePhone: '',
                invoiceContent: '',
                invoiceContentType: 0,
                invoiceMailAddress: '',
                invoiceMoney: '',
                invoiceRemarks: '',
                invoiceTitle: '',
                isVatInvoice: 1,
                taxNo: '',
                taxPoint: '6%',
                Specifications: '',
                ExpressAddress: '',
                ReceivedMoney:0
            },
            refusedInvoiceShow: false,
            refuseReason: "",
            rules: {
                invoiceTitle: [
                    { required: true, message: '请输入发票抬头', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                taxNo: [
                    { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                companyAddress: [
                    { required: true, message: '请输入注册地址', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                companyPhone: [
                    { required: true, message: '请输入注册号码', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                bankName: [
                    { required: true, message: '请输入开户银行', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                bankNo: [
                    { required: true, message: '请输入银行账号', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                invoiceMoney: [
                    { required: true, message: '请输入开票金额', trigger: 'blur' }
                ],
                Specifications: [
                    { required: false, message: '请输入规格型号', trigger: 'blur' },
                    { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                ],
                invoiceRemarks: [
                    { required: true, message: '请输入备注', trigger: 'blur' },
                    { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' }
                ],
                ExpressAddress: [
                    { required: false, message: '请输入邮寄地址', trigger: 'blur' },
                    { min: 1, max: 350, message: '长度在 1 到 350 个字符', trigger: 'blur' }
                ],
                consignee: [
                    { required: true, message: '请输入收件人', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                consigneePhone: [
                    { required: true, message: '请输入收件人电话', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ],
                invoiceMailAddress: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ]

            },
            invoiceContentArray: [
                { name: '*研发和技术服务*技术服务费', value: 1 },
                { name: '*研发和技术服务*技术咨询费', value: 2 },
                { name: '*现代服务*技术服务费', value: 3 },
                { name: '*现代服务*技术咨询费', value: 4 },
                { name: '*现代服务*现场服务', value: 5 },
                { name: '*现代服务*现场技术服务', value: 6 }
            ],
         
            distributionInvoiceId: 0 //重开发票Id
        }
    },
    computed:{
        tipMsg(){
            var msg='提示：请确保电子税务局保持登录状态，否则会影响平台开票业务。';
            if(this.distributionInvoiceId>0&&this.form.ReceivedMoney>0)
            {
                msg='提示：请确保电子税务局保持登录状态，否则会影响平台开票业务，发票已回款￥'+this.form.ReceivedMoney+'，重开发票会先扣除客户该部分额度';
            }
            return msg;
        }
    },
    methods: {
        refuseBtn() {

            if (!this.refuseReason) {
                return this.$message.error('开票原因不能为空')
            }
            this.loading = true
            var data = {
                orderIds: this.form.ids,
                refuseReason: this.refuseReason,
                noteIds: this.form.noteIds,
            };
            refuseInvoice(data).then((r) => {
                this.loading = false
                if (r.Result != 1) {
                    return this.$message.error(r.Message);
                }
                this.$message.success("已拒绝开票");
                this.refusedInvoiceShow = false;
                this.invoiceShow = false;
                this.$parent.GetCouponsList()
                this.$parent.handleReset()
            });
        },

        submitForm(formName) {  
             
            const _this = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    _this.loading = true;
                    var data = {
                        manageUserId: getStorageUserRoleId(),
                        adminUserId: getStorageUserRoleId(),
                        orderIds: _this.form.ids,
                        UserCode: _this.form.senderCode,
                        noteIds: this.form.noteIds,
                        platform: 'zyd',
                        invoiceTitleType: this.form.invoiceTitleType
                    };

                    if (this.form.bankName) data.UserAccountOrgName = this.form.bankName
                    if (this.form.bankNo) data.UserAccountNo = this.form.bankNo
                    if (this.form.companyAddress) data.companyAddress = this.form.companyAddress
                    if (this.form.companyPhone) data.companyPhone = this.form.companyPhone
                    if (this.form.consignee) data.consignee = this.form.consignee
                    if (this.form.consigneePhone) data.consigneePhone = this.form.consigneePhone
                    if (this.form.invoiceContentType > 0) {
                        data.invoiceContent = this.form.invoiceContent;
                        data.invoiceContentType = this.form.invoiceContentType;
                    }
                    // data.invoiceContent = this.form.invoiceContent == 0?'技术服务费':'技术咨询费'

                    if (this.form.invoiceMailAddress) data.invoiceMailAddress = this.form.invoiceMailAddress;
                    if (this.form.invoiceMoney) data.Money = this.form.invoiceMoney
                    if (this.form.Specifications) data.Specifications = this.form.Specifications
                    if (this.form.invoiceRemarks) data.invoiceRemarks = this.form.invoiceRemarks
                    if (this.form.invoiceTitle) data.invoiceTitle = this.form.invoiceTitle
                    data.isVatInvoice = this.form.isVatInvoice == 1 ? true : false
                    if (this.form.taxNo) data.taxNo = this.form.taxNo
                    if (this.form.taxPoint) data.taxPoint = 0.06
                    if (this.form.invoiceDt) data.invoiceDt = this.form.invoiceDt;
                    // if(this.form.invoiceTitleType) data.invoiceTitleType = this.form.invoiceTitleType
                    if (this.form.ExpressAddress) data.ExpressAddress = this.form.ExpressAddress;

                    if (this.distributionInvoiceId > 0) {//重开发票
                        console.log('重开发票'); 
                        data.DistributionInvoiceId=this.distributionInvoiceId;
                        ReInvoiceSubmit(data).then((r) => {
                             _this.loading = false;
                            if (r.Result != 1) {
                                return this.$message.error(r.Message)
                            }
                            this.$message.success('提交成功')
                            this.invoiceShow = false
                            this.$parent.getInvoiceDetail() 
                            
                            //刷新发票列表
                            eventBus.$emit('reloadInvoiceList', 'Some data');
                        });

                    }
                    else { //首次开票
                        console.log('首次开票');

                        confirmInvoice(data).then((r) => {
                            _this.loading = false;
                            if (r.Result != 1) {
                                return this.$message.error(r.Message)
                            }
                            this.$message.success('开票成功')
                            this.invoiceShow = false
                            this.$parent.GetCouponsList()
                            this.$parent.handleReset()
                        });
                    }
                }
            });


        },
 
        /*
            ids:orderId集合
            data：发票信息
            noteIds:节点Id集合
            distributionInvoiceId：发票Id，发票管理里面重开发票时使用
        */
        open(ids, arr, data, noteIds, distributionInvoiceId) {

            this.form = {
                bankName: data.UserAccountOrgName,
                bankNo: data.UserAccountNo,
                companyAddress: data.CompanyAddress,
                companyPhone: data.CompanyPhone,
                consignee: data.Consignee,
                consigneePhone: data.ConsigneePhone,
                finishTime: data.FinishTime,
                invoiceConfirmDt: data.InvoiceConfirmDt,
                invoiceContent: data.InvoiceContent,
                invoiceContentType: data.InvoiceContentType,
                invoiceDt: data.InvoiceDt,
                invoiceMailAddress: data.InvoiceMailAddress,
                invoiceMoney: data.InvoiceMoney,
                invoiceRemarks: data.InvoiceRemarks,
                invoiceReturnPaymentsDt: data.InvoiceReturnPaymentsDt,
                invoiceReturnPaymentsOpDt: data.InvoiceReturnPaymentsOpDt,
                invoiceTitle: data.InvoiceTitle,
                invoiceTitleType: data.InvoiceTitleType,
                isVatInvoice: "1",
                taxNo: data.TaxNo,
                taxPoint: "6%",
                Specifications: data.Specifications,
                ExpressAddress: data.ExpressAddress,
                ReceivedMoney:data.ReceivedMoney
            };
            this.form.info = data;
            this.form.ids = ids;
            this.form.senderCode = arr[0];
            this.form.noteIds = noteIds;
            this.distributionInvoiceId = distributionInvoiceId;
 
            this.invoiceShow = true;
        },
        invoiceClose() {
            this.invoiceShow = false
        },
        invoiceContentTypeChange() {
            var invoiceContent = '';
            for (var i = 0; i < this.invoiceContentArray.length; i++) {
                if (this.invoiceContentArray[i].value == this.form.invoiceContentType) {
                    invoiceContent = this.invoiceContentArray[i].name;
                }
            }
            this.form.invoiceContent = invoiceContent;
            console.log('InvoiceContentTypeContent:' + this.form.invoiceContent);
        }
    }
}
</script>
<style lang="scss">
.tk-head-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .tk-head-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
    }
}

.invoice-dialog {
    .el-select {
        width: 100%;
    }
}


// 解决elment中el-radio控制台报错
/deep/ input[aria-hidden="true"] {
    display: none !important;
}

/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>